import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Admin from './Admin';
import Display from './Display';
import Onboarding from './Onboarding';
import PaymentPage from './PaymentPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

const rawPath = window.location.pathname.replace(/\/+$/, '') || '/';
const pathParts = rawPath.split('/').filter(Boolean);

let Component;

if (pathParts[0] === 'admin' && pathParts[1]) {
  Component = <Admin adminToken={pathParts[1]} />;
} else if (pathParts[0] === 'pago' && pathParts[1]) {
  Component = <PaymentPage paymentToken={pathParts[1]} />;
} else if (pathParts[0] === 'sacar_turno' && pathParts[1]) {
  Component = <App clientToken={pathParts[1]} />;
} else if (pathParts[0] === 'display' && pathParts[1]) {
  Component = <Display clientToken={pathParts[1]} />;
} else {
  Component = <Onboarding />;
}

root.render(Component);
